import { Injectable, inject } from '@angular/core';

import { TranslocoService } from '@ngneat/transloco';

@Injectable({
  providedIn: 'root',
})
export class LanguageDirectionService {
  private translocoService = inject(TranslocoService);

  // Define RTL languages - add more as needed
  private readonly rtlLanguages = ['ar', 'he', 'fa', 'ur'];

  constructor() {
    // Subscribe to language changes
    this.translocoService.langChanges$.subscribe((lang) => {
      this.updateDocumentLanguageAndDirection(lang);
    });

    // Check localStorage for saved language preference
    const savedLang = localStorage.getItem('language');
    if (savedLang && this.translocoService.isLang(savedLang)) {
      this.translocoService.setActiveLang(savedLang);
    }

    // Set initial language on service creation
    const currentLang = this.translocoService.getActiveLang();
    this.updateDocumentLanguageAndDirection(currentLang);
  }

  private updateDocumentLanguageAndDirection(lang: string): void {
    // Update the HTML lang attribute
    document.documentElement.lang = lang;

    // Update the dir attribute based on whether the language is RTL
    if (this.isRtlLanguage(lang)) {
      document.documentElement.dir = 'rtl';
    } else {
      document.documentElement.dir = 'ltr';
    }
  }

  private isRtlLanguage(lang: string): boolean {
    return this.rtlLanguages.includes(lang);
  }

  public isCurrentLanguageRtl(): boolean {
    const currentLang = this.translocoService.getActiveLang();
    return this.isRtlLanguage(currentLang);
  }
}
